(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kt_relatedProduct"]) return;
  try {
    
if (!customElements.get('bj-related-products')) {
  customElements.define('bj-related-products', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded) return;
      this.dataset.loaded = 'true';
      const load = async () => {
        try {
          const response = await fetch(this.dataset.url);
          if (!response.ok || !this.isConnected) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const updated = html.getElementById(this.id);
          const content = updated && updated.querySelector('.bj-related-content');
          if (content && !content.hidden) this.replaceChildren(content);
        } catch (_) {}
      };
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.observer.disconnect();
            load();
          }
        }, { rootMargin: '200px' });
        this.observer.observe(this);
      } else {
        load();
      }
    }
    disconnectedCallback() { if (this.observer) this.observer.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
